(function ($) {
    const App = {
        createSlider: function () {
            $('.js-slider-product-top').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.js-slider-product-all'
            });
            $('.js-slider-product-all').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.js-slider-product-top',
                focusOnSelect: true,
                prevArrow: $('.js-slider-product-prev'),
                nextArrow: $('.js-slider-product-next'),
                responsive: [
                    {
                        breakpoint: 993,
                        settings: {
                            slidesToShow: 7
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 561,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 390,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                ]
            });

            $('.dokument-slider').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: '<div class="common-slider__arrow _prev"><span></span></div>',
                nextArrow: '<div class="common-slider__arrow _next"><span></span></div>',
                dots: true,
                dotsClass: 'common-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })
            $('.product-recommend__slider').slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: '<div class="common-slider__arrow _prev"><span></span></div>',
                nextArrow: '<div class="common-slider__arrow _next"><span></span></div>',
                dots: true,
                dotsClass: 'common-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    }, {
                        breakpoint: 610,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })

            // Перезагрузка сладера при клике, указаного в атрибуте
            $('[data-slider-refresh]').click(function () {
                let slider = $(this).data('slider-refresh');
                $(slider).slick('refresh');
            })


            $('.portfolio-slider').slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: '<div class="portfolio-slider-btn portfolio-slider-btn--prev"><div class="portfolio-slider-prev"></div></div>',
                nextArrow: '<div class="portfolio-slider-btn portfolio-slider-btn--next"><div class="portfolio-slider-next"></div></div>',
                dots: true,
                dotsClass: 'portfolio-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 561,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })
            $('.reviews-content-slider').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: '<div class="reviews-content-slider-btn reviews-content-slider-btn--prev"><div class="reviews-content-slider-prev"></div></div>',
                nextArrow: '<div class="reviews-content-slider-btn reviews-content-slider-btn--next"><div class="reviews-content-slider-next"></div></div>',
                dots: true,
                dotsClass: 'portfolio-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })
            $('.reviews-text-slider').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<div class="reviews-content-slider-btn reviews-content-slider-btn--prev"><div class="reviews-content-slider-prev"></div></div>',
                nextArrow: '<div class="reviews-content-slider-btn reviews-content-slider-btn--next"><div class="reviews-content-slider-next"></div></div>',
                dots: true,
                dotsClass: 'portfolio-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
            })
            $('.reviews-tabs').slick({
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                dots: false,
                arrows: true,
                prevArrow: '<div class="reviews-tab-btn reviews-tab-btn--prev"><div class="reviews-tab-prev"></div></div>',
                nextArrow: '<div class="reviews-tab-btn reviews-tab-btn--next"><div class="reviews-tab-next"></div></div>',
                responsive: [
                    {
                        breakpoint: 561,
                        settings: 'unslick'
                    }
                ]
            })
            $('.reviews-screen-slider').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: '<div class="reviews-content-slider-btn reviews-content-slider-btn--prev"><div class="reviews-content-slider-prev"></div></div>',
                nextArrow: '<div class="reviews-content-slider-btn reviews-content-slider-btn--next"><div class="reviews-content-slider-next"></div></div>',
                dots: true,
                dotsClass: 'portfolio-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 561,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })
            $('.advantages-wrapper').slick({
                mobileFirst: true,
                slidesToShow: 1,
                dots: true,
                arrows: false,
                dotsClass: 'portfolio-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 561,
                        settings: 'unslick'
                    }
                ]
            })
            $('.stocks-block-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                autoplay: true,
                autoplaySpeed: 5000,
                nextArrow: '<div class="projects-arrow__next secondary-slider__btn-right"></div>',
                prevArrow: '<div class="projects-arrow__prev secondary-slider__btn-left"></div>',
                arrows: true,
                dots: true,
                dotsClass: 'stocks-block-slider__paging',
                customPaging: function (slider, i) {
                    if (slider.slideCount > 1) {
                        return '<span class="stocks-active">' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                    }
                },
            });
            $('.hits-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                nextArrow: '<div class="hits-btn hits-btn--next"><div class="hits-slider__btn-right"></div></div>',
                prevArrow: '<div class="hits-btn hits-btn--prev"><div class="hits-slider__btn-left"></div></div>',
                arrows: true,
                dots: true,
                dotsClass: 'hits-slider__paging',
                customPaging: function (slider, i) {
                    return '<span>' + (i + 1) + '</span>' + ' / ' + slider.slideCount;
                },
                responsive: [
                    {
                        breakpoint: 993,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 561,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })

            $('.js-slider-industries-secondary').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
                asNavFor: '.js-slider-industries',
            });
            $('.js-slider-industries').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.js-slider-industries-secondary',
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 2000,
                centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 7
                        }
                    },
                    {
                        breakpoint: 940,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ]
            });

            $('.js-slider-singleServices').each(function (){
                $(this).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                });
            })

            $(window).on('resize', function () {
                $('.advantages-wrapper').slick('resize');
                $('.reviews-tabs').slick('resize');
            });
        },
        menuCatalog: function () {
            $('.sidebar-category-menu .menu-item-has-children > a').append("<span class='sidebar-category-menu__arrow'></span>");
            $(document).on('click', '.sidebar-category-menu__arrow', function (e) {
                e.preventDefault();
                $(this).toggleClass('_active').closest('.menu-item-has-children').toggleClass('_active').find('>.sub-menu').slideToggle();
            });
            if ($('.sidebar-category-menu .current-menu-item').length) {
                $('.sidebar-category-menu .current-menu-ancestor').each(function () {
                    $(this).find('.sidebar-category-menu__arrow').eq(0).trigger('click');
                })
            }

            $('.sidebar-category-menu .sidebar-category-menu__mobail span').html($('.sidebar-category-menu .current-menu-item > a .menu-item-title').html());
            $('.sidebar-category-menu .sidebar-category-menu__mobail').click(function () {
                $(this).find('.sidebar-category-menu__arrow').toggleClass('_active');
                $(this).parent().toggleClass('_active').find('.sidebar-category-menu__list').toggleClass('_active');
            });
            $(document).on('click', function (event) {
                if ($('.sidebar-category-menu').hasClass('_active')) {
                    var item = $(event.target);
                    if (item.closest('body').length != 0 && item.closest('.sidebar-category-menu').length == 0) {
                        $('.sidebar-category-menu .sidebar-category-menu__mobail').trigger('click');
                    }
                }
            })
        },
        menuFooter: function () {
            let footer_menu = $('.footer-nav .footer-menu'),
                footer_menu_left = footer_menu.find('.menu-item:not(.right, .center)'),
                footer_menu_center = footer_menu.find('.menu-item.center'),
                footer_menu_right = footer_menu.find('.menu-item.right');


            footer_menu_left.wrapAll('<ul class="footer-menu-col">');
            footer_menu_right.wrapAll('<ul class="footer-menu-col col_nav">');
            footer_menu_center.wrapAll('<ul class="footer-menu-col">');
        },
        switchTabs: function () {
            $('.description-product__menu-tabs').on('click', '>div:not(._active)', function () {
                $(this).addClass('_active').siblings().removeClass('_active').closest('.description-product')
                    .find('.description-product__tab').removeClass('_active').eq($(this).index()).addClass('_active');
            });
            $('.description-product__btn:eq(0), .description-product__tab:eq(0)').addClass('_active').trigger('click');

            $('.js-show-productExamplesGallery').click(function (){
                $(this).toggleClass('_active');
                $('.js-productExamplesGallery').toggleClass('_active');
                if ($(this).hasClass('_active')) {
                    $(this).find('button').text('Свернуть');
                } else {
                    $(this).find('button').text('Смотреть ещё');
                }
            });
            $('.js-show-productVideoExamplesGallery').click(function (){
                $(this).toggleClass('_active');
                $('.js-productVideoExamplesGallery').toggleClass('_active');
                if ($(this).hasClass('_active')) {
                    $(this).find('button').text('Свернуть');
                } else {
                    $(this).find('button').text('Смотреть ещё');
                }
            });
        },
        seoText: function () {
            $('.seo-text__btn').click(function () {
                $(this).toggleClass('up_active');
                $('.seo-text__hidden').slideToggle();
                if ($(this).hasClass('up_active')) {
                    $(this).text('Свернуть');
                } else {
                    $(this).text('Читать далее');
                }
            });
        },
        DynamicAdapt: function () {
            // data-da=".block,900,last"
            function DynamicAdapt(type) {
                this.type = type;
            }

            DynamicAdapt.prototype.init = function () {
                const _this = this;
                // массив объектов
                this.оbjects = [];
                this.daClassname = "_dynamic_adapt_";
                // массив DOM-элементов
                this.nodes = document.querySelectorAll("[data-da]");
                // наполнение оbjects объктами
                for (let i = 0; i < this.nodes.length; i++) {
                    const node = this.nodes[i];
                    const data = node.dataset.da.trim();
                    const dataArray = data.split(",");
                    const оbject = {};
                    оbject.element = node;
                    оbject.parent = node.parentNode;
                    оbject.destination = document.querySelector(dataArray[0].trim());
                    оbject.breakpoint = dataArray[1] ? dataArray[1].trim() : "767";
                    оbject.place = dataArray[2] ? dataArray[2].trim() : "last";
                    оbject.index = this.indexInParent(оbject.parent, оbject.element);
                    this.оbjects.push(оbject);
                }
                this.arraySort(this.оbjects);
                // массив уникальных медиа-запросов
                this.mediaQueries = Array.prototype.map.call(this.оbjects, function (item) {
                    return '(' + this.type + "-width: " + item.breakpoint + "px)," + item.breakpoint;
                }, this);
                this.mediaQueries = Array.prototype.filter.call(this.mediaQueries, function (item, index, self) {
                    return Array.prototype.indexOf.call(self, item) === index;
                });
                // навешивание слушателя на медиа-запрос
                // и вызов обработчика при первом запуске
                for (let i = 0; i < this.mediaQueries.length; i++) {
                    const media = this.mediaQueries[i];
                    const mediaSplit = String.prototype.split.call(media, ',');
                    const matchMedia = window.matchMedia(mediaSplit[0]);
                    const mediaBreakpoint = mediaSplit[1];
                    // массив объектов с подходящим брейкпоинтом
                    const оbjectsFilter = Array.prototype.filter.call(this.оbjects, function (item) {
                        return item.breakpoint === mediaBreakpoint;
                    });
                    matchMedia.addListener(function () {
                        _this.mediaHandler(matchMedia, оbjectsFilter);
                    });
                    this.mediaHandler(matchMedia, оbjectsFilter);
                }
            };
            DynamicAdapt.prototype.mediaHandler = function (matchMedia, оbjects) {
                if (matchMedia.matches) {
                    for (let i = 0; i < оbjects.length; i++) {
                        const оbject = оbjects[i];
                        оbject.index = this.indexInParent(оbject.parent, оbject.element);
                        this.moveTo(оbject.place, оbject.element, оbject.destination);
                    }
                } else {
                    //for (let i = 0; i < оbjects.length; i++) {
                    for (let i = оbjects.length - 1; i >= 0; i--) {
                        const оbject = оbjects[i];
                        if (оbject.element.classList.contains(this.daClassname)) {
                            this.moveBack(оbject.parent, оbject.element, оbject.index);
                        }
                    }
                }
            };
            // Функция перемещения
            DynamicAdapt.prototype.moveTo = function (place, element, destination) {
                element.classList.add(this.daClassname);
                if (place === 'last' || place >= destination.children.length) {
                    destination.insertAdjacentElement('beforeend', element);
                    return;
                }
                if (place === 'first') {
                    destination.insertAdjacentElement('afterbegin', element);
                    return;
                }
                destination.children[place].insertAdjacentElement('beforebegin', element);
            }
            // Функция возврата
            DynamicAdapt.prototype.moveBack = function (parent, element, index) {
                element.classList.remove(this.daClassname);
                if (parent.children[index] !== undefined) {
                    parent.children[index].insertAdjacentElement('beforebegin', element);
                } else {
                    parent.insertAdjacentElement('beforeend', element);
                }
            }
            // Функция получения индекса внутри родителя
            DynamicAdapt.prototype.indexInParent = function (parent, element) {
                const array = Array.prototype.slice.call(parent.children);
                return Array.prototype.indexOf.call(array, element);
            };
            // Функция сортировки массива по breakpoint и place
// по возрастанию для this.type = min
// по убыванию для this.type = max
            DynamicAdapt.prototype.arraySort = function (arr) {
                if (this.type === "min") {
                    Array.prototype.sort.call(arr, function (a, b) {
                        if (a.breakpoint === b.breakpoint) {
                            if (a.place === b.place) {
                                return 0;
                            }

                            if (a.place === "first" || b.place === "last") {
                                return -1;
                            }

                            if (a.place === "last" || b.place === "first") {
                                return 1;
                            }

                            return a.place - b.place;
                        }

                        return a.breakpoint - b.breakpoint;
                    });
                } else {
                    Array.prototype.sort.call(arr, function (a, b) {
                        if (a.breakpoint === b.breakpoint) {
                            if (a.place === b.place) {
                                return 0;
                            }

                            if (a.place === "first" || b.place === "last") {
                                return 1;
                            }

                            if (a.place === "last" || b.place === "first") {
                                return -1;
                            }

                            return b.place - a.place;
                        }

                        return b.breakpoint - a.breakpoint;
                    });
                    return;
                }
            };
            const da = new DynamicAdapt("max");
            da.init();
        },
        formRating: function () {
            const ratings = document.querySelectorAll('.rating');
            if (ratings.length > 0) {
                initRatings();
            }

            // Основная функция
            function initRatings() {
                let ratingActive, ratingValue;
                // "Бегаем" по всем рейтингам на странице
                for (let index = 0; index < ratings.length; index++) {
                    const rating = ratings[index];
                    initRating(rating);
                }

                // Инициализируем конкретный рейтинг
                function initRating(rating) {
                    initRatingVars(rating);

                    setRatingActiveWidth();

                    if (rating.classList.contains('rating_set')) {
                        setRating(rating);
                    }
                }

                // Инициализайция переменных
                function initRatingVars(rating) {
                    ratingActive = rating.querySelector('.rating__active');
                    ratingValue = rating.querySelector('.rating__value');
                }

                // Изменяем ширину активных звезд
                function setRatingActiveWidth(index = ratingValue.innerHTML) {
                    const ratingActiveWidth = index / 0.05;
                    ratingActive.style.width = `${ratingActiveWidth}%`;
                }

                // Возможность указать оценку
                function setRating(rating) {
                    const ratingItems = rating.querySelectorAll('.rating__item');
                    for (let index = 0; index < ratingItems.length; index++) {
                        const ratingItem = ratingItems[index];
                        ratingItem.addEventListener("mouseenter", function (e) {
                            // Обновление переменных
                            initRatingVars(rating);
                            // Обновление активных звезд
                            setRatingActiveWidth(ratingItem.value);
                        });
                        ratingItem.addEventListener("mouseleave", function (e) {
                            // Обновление активных звезд
                            setRatingActiveWidth();
                        });
                        ratingItem.addEventListener("click", function (e) {
                            // Обновление переменных
                            initRatingVars(rating);

                            if (rating.dataset.ajax) {
                                // "Отправить" на сервер
                                setRatingValue(ratingItem.value, rating);
                            } else {
                                // Отобразить указанную оцнку
                                ratingValue.innerHTML = index + 1;
                                setRatingActiveWidth();
                            }
                        });
                    }
                }

                async function setRatingValue(value, rating) {
                    if (!rating.classList.contains('rating_sending')) {
                        rating.classList.add('rating_sending');

                        // Отправика данных (value) на сервер
                        let response = await fetch('rating.json', {
                            method: 'GET',

                            //body: JSON.stringify({
                            //	userRating: value
                            //}),
                            //headers: {
                            //	'content-type': 'application/json'
                            //}

                        });
                        if (response.ok) {
                            const result = await response.json();

                            // Получаем новый рейтинг
                            const newRating = result.newRating;

                            // Вывод нового среднего результата
                            ratingValue.innerHTML = newRating;

                            // Обновление активных звезд
                            setRatingActiveWidth();

                            rating.classList.remove('rating_sending');
                        } else {
                            alert("Ошибка");

                            rating.classList.remove('rating_sending');
                        }
                    }
                }
            }
        },
        reviewsProduct: function () {
            const button_visibility = () => {
                let this_btn = $('.js-reviews-see-more-btn'),
                    max_post = this_btn.attr('data-max-post'),
                    this_now = $('.js-reviews-box > .card-reviews').length,
                    showposts = this_btn.attr('data-showposts'),
                    left = parseInt(max_post) - parseInt(this_now);
                if (parseInt(max_post) === this_now) {
                    this_btn.hide();
                }
                if (left < parseInt(showposts)) {
                    this_btn.find('span').text('(' + left + ')');
                } else {
                    this_btn.find('span').text('(' + showposts + ')');
                }
            };
            const loadRecord = function () {
                let this_btn = $('.js-reviews-see-more-btn'),
                    page = this_btn.attr('data-page'),
                    idProduct = this_btn.attr('data-id-product');
                order = $('.js-reviews-sort._active').attr('data-order'),
                    sort = $('.js-reviews-sort._active').attr('data-sort');
                $.ajax({
                    url: '/wp-admin/admin-ajax.php?action=loadRecordReviews',
                    type: 'POST',
                    data: {
                        page: page,
                        idProduct: idProduct,
                        sort: sort,
                        order: order
                    },
                    beforeSend: function () {
                        this_btn.prop("disabled", true)
                            .addClass('btn-loading')
                            .append('<span class="btn-loading__spinner"><span class="btn-loading__double-bounce1"></span><span class="btn-loading__double-bounce2"></span></span>');
                    },
                    success: function (data) {
                        $('.js-reviews-box').append(data.reviews);
                        this_btn.attr('data-page', parseInt(page) + 1);
                        if (!data.reviews) {
                            this_btn.hide();
                        }
                        button_visibility();
                        App.formRating();
                    },
                    complete: function () {
                        this_btn.prop("disabled", false)
                            .removeClass('btn-loading').find('.btn-loading__spinner').remove();
                        $('.js-reviews-sort').removeClass('disable');
                    },
                });
            };

            button_visibility();
            $('.js-reviews-see-more-btn').click(loadRecord);

            $('.description-product__btn').on('click', function () {
                if ($(this).hasClass('js-reviews-btn') && !$(this).hasClass('reviews-loaded')) {
                    $(this).addClass('reviews-loaded');
                    $('.js-reviews-see-more-btn').trigger('click');
                }
            });

            $(document.body).on('click', '.js-reviews-sort', function () {
                if (!$(this).hasClass('disable')) {
                    $('.js-reviews-sort').addClass('disable');
                    if ($(this).hasClass('_active')) {
                        if ($(this).attr('data-order') === 'ASC') {
                            $(this).attr('data-order', 'DESC');
                        } else if ($(this).attr('data-order') === 'DESC') {
                            $(this).attr('data-order', 'ASC');
                        }
                    } else {
                        $('.js-reviews-sort').removeClass('_active');
                        $(this).addClass('_active');
                    }
                    $('.js-reviews-see-more-btn').attr('data-page', 1).show();
                    $('.js-reviews-box').empty();
                    loadRecord();
                }
            })
        },
        formValidation: function (form) {
            let valid = true,
                field_validation = form.find('[validation]'),
                message_invalid = '<span class="message-input-error">Это поле обязательно к заполнению.</span>';

            field_validation.each(function () {
                let field = $(this);

                field.next('.message-input-error').remove();

                if (field.attr('validation') === 'text') {
                    if (!field.val().trim()) {
                        field.addClass('_invalid').after(message_invalid);
                        valid = false;
                    } else {
                        field.removeClass('_invalid');
                    }
                }
                if (field.attr('validation') === 'tel') {
                    if (field.val().trim().replace(/\D/g, '').length !== 12) {
                        field.addClass('_invalid').after(message_invalid);
                        valid = false;
                    } else {
                        field.removeClass('_invalid');
                    }
                }
                if (field.attr('validation') === 'checkbox') {
                    field.parent().find('.message-input-error').remove();
                    if (!field.prop('checked')) {
                        field.parent().parent().addClass('_invalid');
                        valid = false;
                    } else {
                        field.parent().parent().removeClass('_invalid');
                    }
                }
                if (field.attr('validation') === 'phone') {
                    if (field.val().trim().replace(/\D/g, '').length !== 12) {
                        field.parent().addClass('_invalid');
                        valid = false;
                    } else {
                        field.parent().removeClass('_invalid');
                    }
                }

                field.on('click', function () {
                    field.removeClass('_invalid');
                    field.parent().removeClass('_invalid');
                    field.parent().parent().removeClass('_invalid');
                    field.next('.message-input-error').remove();
                    if (field.attr('validation') === 'checkbox') {
                        field.parent().find('.message-input-error').remove();
                    }
                })
            });
            if (form.find('.rating [name="rating"]').length) {
                if (!form.find('.rating input[type="radio"][name="rating"]').is(':checked')) {
                    form.find('.rating .rating-error').remove();
                    form.find('.rating').append('<div class="rating-error">Выберите оценку!</div>');
                    valid = false;
                } else {
                    form.find('.rating .rating-error').remove();
                }
                form.find('.rating input[type="radio"][name="rating"]').on('click', function () {
                    form.find('.rating .rating-error').remove();
                })
            }

            return valid;
        },
        sendReviewsProduct: function () {
            const sendReviews = function () {
                let form = $(this),
                    valid = App.formValidation(form),
                    this_btn = form.find('[type="submit"]');

                if (!valid) {
                    form.find('.message-error').remove();
                    form.find('button[type="submit"]').after('<div class="message-error">Одно или несколько полей содержат ошибочные данные. Пожалуйста, проверьте их и попробуйте ещё раз.</div>');
                    return false;
                } else {
                    form.find('.message-error').remove();

                    $.ajax({
                        url: '/wp-admin/admin-ajax.php?action=addReviews',
                        type: 'POST',
                        data: form.serialize() + '&pathname=' + window.location.pathname,
                        beforeSend: function () {
                            this_btn.prop("disabled", true)
                                .addClass('btn-loading')
                                .append('<span class="btn-loading__spinner"><span class="btn-loading__double-bounce1"></span><span class="btn-loading__double-bounce2"></span></span>');
                        },
                        success: function (data) {
                            if (data.status === 'success') {
                                form.trigger('reset');
                                form.parent().append('<div class="form-reviews__success">Отзыв успешно отправлен!</div>');
                                form.remove();
                            } else {
                                alert('Произошла ошибка обработки запроса');
                                this_btn.prop("disabled", false).removeClass('btn-loading').find('.btn-loading__spinner').remove();
                            }
                        },
                        error: function () {
                            alert('Произошла ошибка соединения');
                        },
                        complete: function () {
                            this_btn.prop("disabled", false).removeClass('btn-loading').find('.btn-loading__spinner').remove();
                        },
                    });
                }
                return false;
            };

            $('.js-reviews-send-form').submit(sendReviews);
        },
        showModalWindow: function () {
            // Главная всплывающая форма  ------------------------------------------------
            const showForm = function (e) {
                let title = $(this).data('title'),
                    product_id = $(this).data('product'),
                    harakteristiki = $(this).next().find(".characteristic-product__list .characteristic-product__feature");
                $('#popup-main-form input[name="title"]').val(title);
                $('#popup-main-form input[name="product"]').val(product_id);
                if (harakteristiki.length > 0)
                    harakteristiki.each(function () {
                        if ($(this).next().find("select").length === 0) return
                        const input = document.createElement("input")
                        input.name = "variaciya[" + $(this).text() + "]"
                        input.value = $(this).next().find("select option:selected").text()
                        input.type = "hidden"
                        console.log($(this).next().find("select"));
                        document.querySelector('#popup-main-form form').insertAdjacentHTML("afterbegin", input.outerHTML)
                    });
                $('#popup-main-form').addClass('open');
                $('.overlay-popup').addClass('open');
                $('html').addClass('lock');
            };
            const closeForm = function () {
                $('.overlay-popup').removeClass('open');
                $('.overlay-popup > div').removeClass('open');
                $('html').removeClass('lock');
            };

            $(document).on('click', '.js-show-form', showForm); //Показать форму
            $(document).on('click', '.js-modal-close', closeForm);  //Закрытие формы при клике на крестик

            $(document).on('click', function (event) {  //Закрытие формы подложке при клике на подложку
                if ($('.overlay-popup').hasClass('open') && $('#popup-main-form').hasClass('open')) {
                    let item = $(event.target);
                    if (item.closest('.overlay-popup').length != 0 && item.closest('#popup-main-form').length == 0) {
                        closeForm();
                    }
                }
            });
            // End -- Главная всплывающая форма -----------------------------------------
        },
        utmMarker: function () {
            const params = window.location.search.replace('?', '').split('&').reduce(
                function (p, e) {
                    var a = e.split('=');
                    p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                    return p;
                }, {}
            );
            if (params['utm_source']) {
                document.cookie = "custom_utm_source=" + params['utm_source'] + "; path=/;";
                if (params['utm_campaign']) {
                    document.cookie = "custom_utm_campaign=" + params['utm_campaign'] + "; path=/;";
                }
                if (params['utm_term']) {
                    document.cookie = "custom_utm_term=" + params['utm_term'] + "; path=/;";
                }
            }
            if (params['yclid']) {
                document.cookie = "custom_yclid_source=" + params['yclid'] + "; path=/;";
            }
            if (params['ysclid']) {
                document.cookie = "custom_ysclid_source=" + params['ysclid'] + "; path=/;";
            }
        },
        file_input: function () {
            $('input[type="file"]').change(function () {
                $.each($('input[type=file]').prop("files"), function (k, v) {
                    var filename = v['name'];
                    $('.ask-question-form-file p').text(filename);
                });
            });
        },
        sendForms: function () {
            const showThank = function () {
                window.setTimeout(function () {
                    $('#popup-thank').addClass('open');
                    $('.overlay-popup').addClass('open');
                }, 1500);
                window.setTimeout(function () {
                    $('#popup-thank').removeClass('open');
                    $('.overlay-popup').removeClass('open');
                }, 5000);
            };
            const closeForm = function () {
                $('.overlay-popup').removeClass('open');
                $('.overlay-popup > div').removeClass('open');
                $('html').removeClass('lock');
            };

            const sendPost = function () {
                let form = $(this),
                    valid = App.formValidation(form);
                // dataForm = form.serialize();

                if (!valid) {
                    return false;
                } else {
                    $.ajax({
                        type: "POST",
                        url: "/wp-admin/admin-ajax.php?action=sendPost",
                        contentType: false,
                        processData: false,
                        data: new FormData(this),
                        beforeSend: function () {
                            form.find('button[type="submit"]').prop("disabled", true)
                                .addClass('btn-loading')
                                .append('<span class="btn-loading__spinner"><span class="btn-loading__double-bounce1"></span><span class="btn-loading__double-bounce2"></span></span>');
                        },
                        success: function (data) {
                            if (data.status == 'success') {
                                form.trigger('reset');
                                ym(95051838,'reachGoal','send-form');
                                gtag('event', 'send-formG', {'event_category': 'form'});
                                closeForm();
                                showThank();
                            } else if (data.status == '10MB') {
                                alert('Файл больше 10 Мб');
                                form.trigger('reset');
                            } else if (data.status == '400') {
                                alert('Не верный формат файла');
                                form.find('.ask-question-form-file input[type="file"]').val('');
                                form.find('.ask-question-form-file p').text('Прикрепить файл');
                            } else {
                                alert('Произошла ошибка обработки запроса');
                            }
                            form.find('.ask-question-form-file input[type="file"]').val('');
                            form.find('.ask-question-form-file p').text('Прикрепить файл');
                        },
                        error: function () {
                            alert('Произошла ошибка соединения');
                        },
                        complete: function () {
                            form.find('button[type="submit"]').prop("disabled", false)
                                .removeClass('btn-loading').find('.btn-loading__spinner').remove();
                        },
                    });
                }
                return false;
            };
            $('.ask-question-form-file input[type="file"]').bind('change', function () {
                if (typeof this.files[0] === "undefined") {
                    $('.ask-question-form-file input[type="file"]').val('');
                    $('.ask-question-form-file p').text('Прикрепить файл');
                } else if (this.files[0].size > 10 * 1024 * 1024) {
                    alert('Файл больше 10 Мб');
                    $('.ask-question-form-file input[type="file"]').val('');
                    $('.ask-question-form-file p').text('Прикрепить файл');
                }
            });
            $('form:not(.js-catalog-filters, .searchform)').submit(sendPost); //Отправка формы
        },
        customCheckbox: function () {
            let checkbox = $('input[type="checkbox"]');
            if (checkbox.length) {
                checkbox.each(function () {
                    $(this).wrap('<div class="custom-checkbox"></div>').after('<label for="' + $(this).attr('id') + '" class="custom-checkbox__check"></label>');
                })
            }
        },
        filtersCatalog: function () {
            const catalog_filters_range = $('.js-catalog-filters-range'),
                catalog_filters = $('.js-catalog-filters');

            catalog_filters.on('submit-form', function (e) {
                let form = $(this);
                e.preventDefault();
                setTimeout(function () {
                    catalog_filters.addClass('_loading');
                    form.trigger('submit');
                }, 1000);

            });

            if (catalog_filters_range.length) {
                catalog_filters_range.each(function () {
                    let range_slider = $(this).find('.js-catalog-filters-range-slider'),
                        min = parseFloat(range_slider.data('min')),
                        max = parseFloat(range_slider.data('max')),
                        input0 = $(this).find('.js-catalog-filters-range-from'),
                        input1 = $(this).find('.js-catalog-filters-range-to'),
                        inputs = [input0[0], input1[0]],
                        is_float = range_slider.data("float") == 1,
                        start = [min, max]
                    if (input0.data('value') != null) {
                        start[0] = input0.data('value')
                    }
                    if (input1.data('value') != null) {
                        start[1] = input1.data('value')
                    }
                    noUiSlider.create(range_slider[0], {
                        start: start,
                        behaviour: 'tap',
                        connect: true,
                        //tooltips: true,
                        range: {
                            'min': min,
                            'max': max
                        },
                        pips: {
                            mode: 'values',
                            values: [min, max],
                            density: 2,
                            format: {
                                from: function (value) {
                                    if (is_float) {
                                        return Number(value).toFixed(1);
                                    }
                                    return parseInt(value);
                                },
                                to: function (value) {
                                    if (is_float) {
                                        return Number(value).toFixed(1);
                                    }
                                    return parseInt(value);
                                }
                            }
                        },
                        format: {
                            from: function (value) {
                                if (is_float) {
                                    return Number(value).toFixed(1);
                                }
                                return parseInt(value);
                            },
                            to: function (value) {
                                if (is_float) {
                                    return Number(value).toFixed(1);
                                }
                                return parseInt(value);
                            }
                        }
                    });

                    inputs[0].value = false;
                    inputs[1].value = false;
                    range_slider[0].noUiSlider.on('update', function (values, handle) {
                        if (min === Number(values[0])) {
                            inputs[0].value = '';
                        } else {
                            inputs[0].value = values[0];
                        }
                        if (max === Number(values[1])) {
                            inputs[1].value = '';
                        } else {
                            inputs[1].value = values[1];
                        }
                    });
                    range_slider[0].noUiSlider.on('change', function (values, handle) {
                        catalog_filters.trigger('submit-form');
                    });

                    const minHandler = e => {
                        range_slider[0].noUiSlider.set([e.target.value, null]);
                        catalog_filters.trigger('submit-form');
                    };
                    const maxHandler = e => {
                        range_slider[0].noUiSlider.set([null, e.target.value]);
                        catalog_filters.trigger('submit-form');
                    };
                    input0.on('change', minHandler);
                    input1.on('change', maxHandler);
                });
            }
            catalog_filters.on('change', 'input', function () {
                catalog_filters.trigger('submit-form');
            });

            $('.js-catalog-filters-clear').on('click', function (e) {
                e.preventDefault();
                let catalog_filters = $('.js-catalog-filters'),
                    sliderUi = $('.js-catalog-filters-range-slider');

                catalog_filters.find('input:checked').each(function (e, item) {
                    item.checked = false;
                });


                sliderUi.each(function (index, element) {
                    $(this)[0].noUiSlider.set([$(element).data('min'), $(element).data('max')])
                });
                catalog_filters.trigger('submit-form');
            });
        },
        sortCatalog: function () {
            if (document.querySelector(".sort__list") !== null) {
                document.querySelectorAll(".sort__list .sort__list--element").forEach(item => {
                    item.addEventListener("click", e => {
                        if (e.target.dataset.order != null) {
                            document.querySelector("form.filters-catalog input[name='order']").value = e.target.dataset.order
                        } else {
                            document.querySelector("form.filters-catalog input[name='order']").value = null
                        }
                        if (e.target.dataset.orderBy != null) {
                            document.querySelector("form.filters-catalog input[name='orderBy']").value = e.target.dataset.orderBy
                        } else {
                            document.querySelector("form.filters-catalog input[name='orderBy']").value = null
                        }
                        document.querySelectorAll(".sort__list .sort__list--element.active").forEach(item2 => {
                            item2.classList.remove("active")
                        })
                        e.target.classList.add("active")
                        document.querySelector(".single-tax__subtitle .sort > :first-child").innerText = e.target.innerText
                        document.querySelector("form.filters-catalog").dispatchEvent(new Event("submit-form"))
                    })
                })
            }
        },
        variationSelect: function () {
            if (document.querySelector('select.variation_select') !== null) {
                document.querySelectorAll('select.variation_select').forEach(item => {
                    item.addEventListener("change", e => {
                        let allSelect = ''
                        document.querySelectorAll('select.variation_select').forEach(item2 => {
                            allSelect += "&" + item2.name + "=" + item2.value
                        })
                        const xhr = new XMLHttpRequest(),
                            data = `action=getVariation&postID=${e.target.dataset.postId}${allSelect}`
                        xhr.onreadystatechange = () => {
                            if (xhr.readyState === 4 && xhr.status === 200) {
                                const response = JSON.parse(xhr.response)
                                if (response.status === 'success') {
                                    if (response.akczionnaya_czena != null && response.akczionnaya_czena !== '') {
                                        if (document.querySelector(".single-catalog__price span.old-price") === null)
                                            document.querySelector(".single-catalog__price span:last-of-type").insertAdjacentHTML("beforebegin", "<span class='old-price'></span>")
                                        document.querySelector(".single-catalog__price span:last-of-type").innerText = response.akczionnaya_czena
                                        document.querySelector(".single-catalog__price span.old-price").innerText = response.czena
                                    } else {
                                        if (document.querySelector(".single-catalog__price span.old-price") !== null)
                                            document.querySelector(".single-catalog__price span.old-price").remove()
                                        document.querySelector(".single-catalog__price span:last-of-type").innerText = response.czena
                                    }
                                } /*else if (response.status === "error"){
                                  if (response.code === 404){
                                      if (response.variation.akczionnaya_czena != null && response.variation.akczionnaya_czena !== ''){
                                          document.querySelector(".single-catalog__price span:last-of-type").innerText =response.variation.akczionnaya_czena
                                          document.querySelector(".single-catalog__price span.old-price").innerText =response.variation.czena
                                      } else {
                                          document.querySelector(".single-catalog__price span:last-of-type").innerText = response.variation.czena
                                      }
                                      response.variation.harakteristiki.forEach(item => {
                                          document.querySelector("option[value='"+item.harkteristiki+"']").closest("select").value = item.harkteristiki
                                      })
                                  }
                              }*/
                            }
                        }
                        xhr.open("POST", "/wp-admin/admin-ajax.php")
                        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
                        xhr.send(data)
                    })
                })
            }
        },
        selectDescription: function () {
            $('.description-product__menu_open').on('click', function () {
                $('.description-product__menu_open').toggleClass('_active');
                $('.description-product__menu_ul').slideToggle();

            })
            $('.description-product__menu_ul').on('click', '>li:not(._active)', function () {
                $(this).addClass('_active').siblings().removeClass('_active').closest('.description-product')
                    .find('.description-product__tab').removeClass('_active').eq($(this).index()).addClass('_active');
            });
            $('.description-product__btn_li:eq(0), .description-product__tab:eq(0)').addClass('_active').trigger('click');
            const select = document.querySelector('.description-product__menu_open'),
                li = document.querySelectorAll('.description-product__btn_li');
            li.forEach(item => {
                if (item.classList.contains('_active')) {
                    select.textContent = item.textContent;
                }
                item.addEventListener('click', () => {
                    select.textContent = item.textContent;
                    $('.description-product__menu_ul').slideUp();
                    $('.description-product__menu_open').removeClass('_active');
                })
            })

        },
        headerMenu: function () {
            $('.header__btn_menu, .header__btn_close_burger').on('click', function () {
                $('html').toggleClass('lock-menu');
                $('.nav__items').toggle({
                    duration: 600,
                    start: function () {
                        if ($('.header-input_search').is(':visible')) {
                            $('.header-input_search').hide(1000);
                            $('.header__btn_search').show(500);
                            $('.header__btn_close_search').hide(500);
                        }
                        $('.header-contacts').toggle({duration: 700, easing: "swing",});
                    },
                    done: function () {
                        if (($('.nav__items').is(':visible'))) {
                            $('.header__btn_menu').hide(300);
                            $('.header__btn_close_burger').show(300);
                        } else {
                            $('.header__btn_close_burger').hide(300);
                            $('.header__btn_menu').show(300);
                        }
                    }
                });
            });
        },
        headerSearch: function () {
            $('.header__btn_search, .header__btn_close_search').on('click', function () {
                $('html').toggleClass('lock-menu');
                $('.header-input_search').slideToggle({
                    start: function () {
                        if ($('.nav__items').is(':visible')) {
                            $('.nav__items, .header-contacts').hide(800);
                            $('.header__btn_close_burger').hide(200);
                            $('.header__btn_menu').show(200);
                        }
                    },
                    done: function () {
                        if ($('.header-input_search').is(':visible')) {
                            $('.header__btn_search').hide(200);
                            $('.header__btn_close_search').show(200);
                        } else {
                            $('.header__btn_close_search').hide(200);
                            $('.header__btn_search').show(200);
                        }
                    }

                });
            });
        },
        menuSearch: function () {
            $(document.querySelector('.header__btn_search_menu')).on('click', function () {
                $('.header-input_search_menu').show(1000);
                $('.header__btn_search_menu').hide(500);
                $('.header__btn_close_menu').show(500);
            });
            $(document.querySelector('.header__btn_close_menu')).on('click', function () {
                $('.header-input_search_menu').hide(1000);
                $('.header__btn_close_menu').hide(500);
                $('.header__btn_search_menu').show(500);
            });
        },
        selectHarka: function () {
            $('.feature-open').on('click', function () {
                $(this).closest('.characteristic-product__feature_mobile').find('.value_mobile').slideToggle();
                $(this).closest('.characteristic-product__feature_mobile').find('.sidebar-product-harka__arrow').toggleClass('_active');
            });
        },
        touchScroll: function () {
            //js
            let scrollAll = document.querySelectorAll('.touchScroll');

            scrollAll.forEach(function (scroll) {
                scroll.classList.add('grab');

                let left = 0; // отпустили мышку - сохраняем положение скролла
                let drag = false;
                let coorX = 0; // нажали мышку - сохраняем координаты.

                scroll.addEventListener('mousedown', function (e) {
                    drag = true;
                    coorX = e.pageX - this.offsetLeft;
                    scroll.classList.remove('grab');
                    scroll.classList.add('grabbing');
                });
                document.addEventListener('mouseup', function () {
                    drag = false;
                    left = scroll.scrollLeft;
                    scroll.classList.add('grab');
                    scroll.classList.remove('grabbing');
                });
                scroll.addEventListener('mousemove', function (e) {
                    if (drag) {
                        this.scrollLeft = left - (e.pageX - this.offsetLeft - coorX);
                    }
                });
            })
            //js
        },
        hoverMap: function () {
            //js
            document.querySelectorAll('.flags_class').forEach(function (item) {
                item.addEventListener('mouseenter', function (e) {
                    document.querySelectorAll('.flags_class').forEach(item2 => {
                        item2.classList.remove('active');
                        item2.classList.add('hide');
                    })
                    e.target.classList.add('active');
                    e.target.classList.remove('hide');
                });
                item.addEventListener('mouseleave', function (e) {
                    document.querySelectorAll('.flags_class').forEach(item2 => {
                        item2.classList.remove('active');
                        item2.classList.remove('hide');
                    })
                });
            })
            //js
        },
        switchGalleriesTabs: function () {
            //js
            document.querySelectorAll('.switch__tab').forEach(function (item, index) {
                item.addEventListener('click', function () {
                    document.querySelectorAll('.switch .active').forEach(function (elm) {
                        elm.classList.remove('active');
                    });

                    let galleryArr = document.querySelectorAll('.switch__content');
                    let subtitleArr = document.querySelectorAll('.switch__subtitle');

                    item.classList.add('active');
                    galleryArr[index].classList.add('active');
                    if (subtitleArr.length !== 0)
                        subtitleArr[index].classList.add('active');
                })
            })
            //js
        },
        smoothScroll: function () {
            $('a[href^="#"]').on('click', function () {

                let href = $(this).attr('href');

                $('html, body').animate({
                    scrollTop: $(href).offset().top
                });
                return false;
            });

            $('a[href*="#"]').on('click', function () {
                if ($('html').hasClass('lock-menu')){
                    $('html').toggleClass('lock-menu');
                    $('.nav__items').toggle({
                        duration: 600,
                        start: function () {
                            if ($('.header-input_search').is(':visible')) {
                                $('.header-input_search').hide(1000);
                                $('.header__btn_search').show(500);
                                $('.header__btn_close_search').hide(500);
                            }
                            $('.header-contacts').toggle({duration: 700, easing: "swing",});
                        },
                        done: function () {
                            if (($('.nav__items').is(':visible'))) {
                                $('.header__btn_menu').hide(300);
                                $('.header__btn_close_burger').show(300);
                            } else {
                                $('.header__btn_close_burger').hide(300);
                                $('.header__btn_menu').show(300);
                            }
                        }
                    });
                }
            });
        },
        displayImagesWhenHoveringOverAnObject: function () {
            let material = $('.text-block__material');
            if (material.length) {
                material.each(function () {
                    $(this).on('mouseover', function () {
                        //first = true;
                        $('.text-block__img-hover > img').eq($(this).index()).addClass('_visible');
                    }).on('mouseleave', function (e) {
                        $('.text-block__img-hover > img').eq($(this).index()).removeClass('_visible');
                    });
                })
            }
        },
        table: function () {
            $('table').wrap('<div class="wrapper-table">');
        },
        headerFixedMenu: function () {
            let lastScrollTop = 0;
            $(window).on('scroll', function () {
                let header = $('.header'),
                    body = $('body');
                if ($(window).scrollTop() > header.height() + 100) {
                    let posit = $(this).scrollTop();
                    if (posit > lastScrollTop) {
                        // Действие при прокрутке вниз
                        header.removeClass('_fixed');
                        body.removeClass('_fixed-menu');
                    } else {
                        // Действие при прокрутке вверх
                        if (!header.hasClass('_fixed')) {
                            header.addClass('_fixed');
                            body.addClass('_fixed-menu');
                        }
                    }
                    lastScrollTop = posit;
                } else {
                    header.removeClass('_fixed');
                    body.removeClass('_fixed-menu');
                }
            });
        },
        init: function () {
            this.createSlider();
            this.menuCatalog();
            this.menuFooter();
            this.reviewsProduct();
            this.switchTabs();
            this.seoText();
            this.DynamicAdapt();
            this.formRating();
            this.sendReviewsProduct();
            this.utmMarker();
            this.showModalWindow();
            this.file_input();
            this.sendForms();
            this.customCheckbox();
            this.filtersCatalog();
            this.sortCatalog();
            this.variationSelect();
            this.headerMenu();
            this.headerSearch();
            this.menuSearch();
            this.selectDescription();
            this.selectHarka();
            this.touchScroll();
            this.hoverMap();
            this.switchGalleriesTabs();
            this.smoothScroll();
            this.displayImagesWhenHoveringOverAnObject();
            this.table();
            this.headerFixedMenu();
        }
    };
    $(document).ready(function () {
        App.init();
    });


})(jQuery);